import { useState } from "react";
//Import bootstrap items
import { Button, Form, Row } from "react-bootstrap";
//Import auth hook
import useAuth from "../../utils/authentication";
//Import navigation
import { useNavigate } from "react-router-dom";
// Import footer
import { TailSpin } from "react-loading-icons";
import { toast } from "react-toastify";
import Footer from "../../components/Footer";

import "../../styles/sass/components/Login/Login.scss";

const Login = () => {
 
  const [email, setEmail] = useState();
  const [pass, setPass] = useState();
  const { login, authed } = useAuth();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false); 


  if (authed) {
    toast.success("Already logged in!"); 
    navigate("/home", { replace: true });
  }

  const handleLogin = async (e) => {
    setIsLoading(true); 
    e.preventDefault(); 
    await login(email, pass)
      .then((result) => {
        if (result === true) {
          toast.success("Login successful!");
          navigate("/home", { replace: true });
          return;
        }
      })
      .catch((err) => {
        setIsLoading(false); 
        if (err === "unauthorized" || err === "auth_fail") {
          toast.error("Invalid email or password");
          return;
        } else {
          toast.error("An error occurred. Please try again later.");
          return;
        }
      });
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };
  const handlePassChange = (e) => {
    setPass(e.target.value);
  };

  return (
    <Form className="login-page-form" onSubmit={handleLogin}>
      <Row className="login-row-form">
        <h6 className="member-login-page">Sign Into XAPiT</h6>
        <div className="login-page-input-container">
          Email Address
          <Form.Control
            type="text"
            placeholder="Email"
            onChange={handleEmailChange}
          ></Form.Control>
        </div>
        <div className="login-page-input-container">
          Password
          <Form.Control
            type="password"
            placeholder="Password"
            onChange={handlePassChange}
          ></Form.Control>
        </div>
        <div className="login-page-button-container">
          <Button type="submit" disabled={isLoading}>{isLoading ? (<TailSpin strokeWidth="5px" style={{height: "1.3rem"}}/>) : "Login"}</Button>
        </div>
        <div className="login-page-sign-up">
          <p>
            Don't have an account? <a href="/signup">Sign up</a>
          </p>
        </div>
        <div className="login-page-sign-up"
          style={{
            margin: 0
          }}
        >
          <p>
            Forgot your password? <a href="/forgot-password">Reset it</a>
          </p>
        </div>
      </Row>
      <Footer />
    </Form>
  );
};

export default Login;
